import { Stack, Typography } from "@mui/material"
import type { RefObject } from "react"
import { Trans, useTranslation } from "react-i18next"

import { useAuth } from "../../../../api"
import type { Challenge } from "../../../../api/hooks/vote"
import { format } from "../../../../utils"
import { Time } from "../../../@shared"
import { SubmitButton } from "../submit-button"
import { useVoting } from "../vote-context"
import { BackForthPagination } from "./paginated-buttons"

interface ControlsProps {
	challenge: Challenge
	entriesContainer: RefObject<HTMLDivElement>
	loading: boolean
	onVotingEnded(): void
}

export const Controls = ({
	entriesContainer,
	challenge,
	loading,
	onVotingEnded,
}: ControlsProps) => {
	const { authorized } = useAuth()
	const { t } = useTranslation("vote")
	const { currentVotes, isEnoughVotes } = useVoting()

	const { votingClosesAt } = challenge

	return (
		<Stack
			maxWidth='90%'
			width='600px'
			mx='auto'
			alignItems='center'
			textAlign='center'
		>
			<BackForthPagination
				entriesContainer={entriesContainer}
				isEnoughVotes={isEnoughVotes}
				loading={loading}
			/>
			{!isEnoughVotes && (
				<Typography
					color='warning.dark'
					variant='subtitle2'
					component='p'
					mb={1}
					role='status'
				>
					{t("progress.notEnoughVotes", {
						count: 3 - currentVotes,
					})}
				</Typography>
			)}
			<SubmitButton
				challenge={challenge}
				buttonText={t("progress.submit")}
				disabled={!isEnoughVotes}
				onWarning={onVotingEnded}
			/>
			<Typography fontWeight='bold'>{t("progress.title")}</Typography>
			<Typography>
				{authorized ? (
					<>
						{t("progress.enoughVotesDetails")}
						<Trans
							t={t}
							i18nKey='progress.enoughVotesRegistered'
							values={{
								date: format(votingClosesAt, "eee, MMM d"),
								time: format(votingClosesAt, "ha z"),
							}}
						>
							<Time children={undefined} />
						</Trans>
					</>
				) : (
					t("progress.enoughVotesDetails")
				)}
			</Typography>
		</Stack>
	)
}
